import { OTP_PROOFKEY, OTP_TOKEN } from '@/lib/consts/auth';
import { SESSION_STORAGE_KEYS } from '@/lib/consts/sessionStorage';
import { createSingleUseLoginGuard } from './singleUseLoginGuard';

const otpGuard = createSingleUseLoginGuard({
    scope: 'session',
    storageKey: SESSION_STORAGE_KEYS.OTP_LOGIN_ATTEMPTED,
    urlParams: [OTP_PROOFKEY, OTP_TOKEN],
});

/**
 * Marks an OTP credential as already consumed by auto-login.
 * Keyed by access token when present, otherwise by proofKey, so a later
 * distinct OTP callback in the same tab can still run.
 */
export const markOtpLoginAttempted = (credential: string): void => {
    otpGuard.markAttempted(credential);
};

export const isOtpLoginAttempted = (credential: string): boolean => otpGuard.isAttempted(credential);

/**
 * Strip OTP callback params immediately so a remount no longer looks like a
 * fresh OTP return (`isOTPLogin()` becomes false).
 */
export const clearOtpLoginParamsFromUrl = (): void => {
    otpGuard.clearParamsFromUrl();
};
